import React from 'react';
import { Summary } from '.';

interface TotalProps {
  totalUnits: number;
  isSelectedItemReturnItem?: boolean;
  totalPages: number;
}

export const Total = ({
  isSelectedItemReturnItem,
  totalUnits,
  totalPages,
}: TotalProps): JSX.Element => {
  return (
    <Summary
      heading={'CashOfficeView_TotalSubTitle'}
      value={totalUnits}
      marginNeeded={isSelectedItemReturnItem || totalPages < 2}
    />
  );
};
